import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const getStateApi = createAsyncThunk('state', async () => {
    const response = await axiosInstance.get('/augmontGold/states');
    return response.data;
});

const stateSlice = createSlice({
    name: "state",
    initialState: {
        data: [],
        errors: [],
        status: "idle"
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStateApi.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getStateApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = "idle";
            })
            .addCase(getStateApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.status = "idle";
            });
    }
});

export default stateSlice.reducer;
